import Vue from './common/vue-common';
import cr$ from '../../../submodules/src/script/crquery';
import HeaderMenu from '../../../submodules/src/componentsV2/header/HeaderMenu.vue';
import HeaderMobile from '../../../submodules/src/componentsV2/header/HeaderMobile.vue';
import Advantages from './components/common/Advantages.vue';

cr$.ready(() =>
    requestIdleCallback(() => {
        if (cr$.byId('header-desktop-nav').exists()) {
            new Vue(HeaderMenu);
        }
        if (cr$.byId('header-mobile-nav').exists()) {
            new Vue({
                el: '#header-mobile-nav',
                template: `
                    <HeaderMobile>
                        <template v-slot:advantages>
                            <Advantages />
                        </template>
                    </HeaderMobile>
                `,
                components: { HeaderMobile, Advantages },
            });
        }
    })
);
